// src/services/authApi.ts
import { api } from './api';

export interface LoginRequest {
  username: string;
  password: string;
}

export interface AuthResponseUser {
  id: number;
  username: string;
  email: string;
  // Additional fields as needed
}

export interface LoginResponse {
  jwt: string;
  user: AuthResponseUser;
}

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: ({ username, password }) => ({
        url: '/auth/local',
        method: 'POST',
        body: { identifier: username, password },
      }),
      
    }),
  }),
  overrideExisting: false, // Set to true if you need to override endpoints in hot reload scenarios
});

// Auto-generated hook for the login mutation
export const { useLoginMutation } = authApi;